import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function LatestArticles() {
  const latest = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 5);

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-20">
        <SectionHeading eyebrow="最新档案" title="刚刚整理完的内容" />

        <div className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-8">
            <div className="rounded-lg border border-background-200 bg-background-50 px-5 md:px-7">
              {latest.map((article) => (
                <ArticleCard key={article.slug} article={article} variant="list" />
              ))}
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="sticky top-28 space-y-6">
              <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                <h3 className="font-heading text-base font-bold text-foreground-950">按分类浏览</h3>
                <ul className="mt-4 space-y-2">
                  {categories.map((cat) => (
                    <li key={cat.slug}>
                      <Link
                        to={`/archives?category=${cat.slug}`}
                        className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
                      >
                        <span className="flex items-center gap-2.5">
                          <i className={`${cat.icon} text-base text-primary-600`} aria-hidden="true"></i>
                          {cat.name}
                        </span>
                        <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-lg border border-accent-200 bg-accent-50 p-5 md:p-6">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className="ri-phone-line text-lg" aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-accent-900">已经有人失联了？</h3>
                <p className="mt-2 text-sm leading-relaxed text-accent-800">
                  先固定聊天记录与转账凭据，再向公安机关报案登记，并联系使领馆寻求协助。不要轻信付费捞人的中间人。
                </p>
                <Link
                  to="/archives/family-rescue-guide"
                  className="mt-4 inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-accent-700 transition-colors hover:text-accent-900"
                >
                  查看家属应对流程
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}